<template>
  <div class="login">
    <div class="login-content">
      <div class="new-wrapper login-box">
        <div class="login-title">云联淘生活</div>
        <div class="wx-form-box">
          <div class="login-body">
            <div class="form-group first">
              <h2 class="title">用户登陆</h2>
            </div>
            <div class="form-group ">
              <div class="input-box">
                  <img class="user-icon" src="../assets/images/login-user-icon.png" />
                  <input type="text" 
                    v-model="account" 
                    class="form-control user-input" 
                    placeholder="请输入账号" 
                    maxlength="30"  
                    autocomplete="off" />
                </div>
            </div>
            <div class="form-group">
              <div class="input-box">
                <img class="user-icon" src="../assets/images/login-password-icon.png" />
                <input type="password" 
                  v-model="password" 
                  class="form-control user-input" 
                  placeholder="请输入密码" 
                  maxlength="30" 
                  autocomplete="off"
                  v-on:keyup.13="login" />
              </div>
            </div>
            <!-- <div class="form-group">
              <input type="tel" v-model="code" class="form-control login-code" autocomplete="off" placeholder="请输入验证码" maxlength="6" />
              <validcode @incre="RefreshCode"></validcode>           
            </div> -->
            <div class="login-footer form-group">
              <button type="button" class="login-btn" v-on:click="login()" >登录</button>
            </div>
          </div>
        </div>      
      </div>
    </div>
    <footer>
      <a class="qq-btn" target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=412559867&amp;site=qq&amp;menu=yes">联系客服</a>
      <img src="../assets/images/login-qrcode.png" style="vertical-align: top;">
    </footer>
  </div>
</template>
<script  type='text/ecmascript-6'>
 const ERR_OK=0;
  import validcode from '@/components/Security.vue'
  // import { Message } from 'element-ui'
  export default {
    props:{
    },
    data (){
      return {
        account:'',
        password:'',
        code:'',
        identifyCode: '',
        checked: false
      }
    },
    computed:{
    },
    mounted(){
      
    },
    methods:{
      login:function(){
        // if(this.identifyCode.toLowerCase() != this.code.toLowerCase()){
        //   this.$message({
        //     showClose: true,
        //     message: '请输入正确的验证码',
        //     type: 'warning'
        //   });
        //   return;
        // }
        var that = this
        this.axios.post(this.global.serverSrc + '/api/User/Login',{
          account : that.account,
          password : that.password
        }).then(function (resp) { 
          if(resp.data.errorCode==0){ 
            sessionStorage.setItem('token', resp.data.token)
            that.getUserInfo()
          }else {
            that.$message({
              showClose: true,
              message: resp.data.message,
              type: 'warning'
            });
          }
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      getUserInfo:function(){
        var that = this
        this.axios.post(
          '/User/UserLoginInfo',
          {}
        ).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$cookie.set('user', resp.data.user);
            //that.$cookie.set('menus', resp.menu);
            sessionStorage.setItem('menus',JSON.stringify( resp.data.menu.permissions))
            that.$router.push('/home');
          }else {
            that.$message({
              showClose: true,
              message: resp.data.message,
              type: 'warning'
            });
          }
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      RefreshCode:function(newCode){
        this.identifyCode = newCode
      }        
    },
    components:{    
      validcode 
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .login
    height 100%
    background #409beb
    overflow hidden
    min-width auto 
    background-image url(../assets/images/login-cover-bg.png)
    .login-content
      .new-wrapper
        width 400px
        margin 0 auto
        margin-top 60px
        color #fff
        .login-title
          margin-bottom 25px
          text-align center
          margin-right -41px
          font-size 40px
        .wx-form-box
          height 328px
          width 323px
          padding 0 77px
          background-color rgba(265,265,265,0.2)
          border-radius 12px
          z-index 999
          .form-control
            background-color #ffffff
            color #636363
            font-size 13px
            line-height 1.428571429
            vertical-align middle
            border-radius 4px
            text-align left
          .login-body
            display block
            .form-group
              margin-top 25px
              .title
                text-align center
                font-size 18px
              .input-box
                width 329px
                height 37px
                border-radius 18px
                background-color #fff
                font-size 16px  
                img
                  vertical-align middle
                .user-icon
                  width 20px
                  margin-left 10px
                .user-input
                  border none
                  width 280px
                  height 37px
                  padding 0
              .login-code
                display inline-block
                float left 
                width 120px
                height 37px
                margin-right 10px
                border-radius 18px
                border none
              .code
                display inline-block
                float left
                margin-left 10px
            .first
              padding-top 40px
            .login-footer
              margin-top 40px 
              .login-btn
                width 100%
                height 42px
                font-size 19px
                font-weight 300
                background-color rgba(0,159,255,1)
                border none
                color #ffffff
                border-radius 10px
                padding 0
                letter-spacing 12px
                text-indent 16px
                outline none
    footer
      width 100%
      height 120px;
      z-index 100;
      position absolute
      bottom 0
      left 0
      background-image url(../assets/images/login-data-bg-bottom.png)
      background-size 100% 100%
      background-position center center
      text-align center
      padding-top 20px
      .qq-btn
        height: 78px
        letter-spacing: 8px
        display: inline-block
        padding: 6px 30px 6px 40px
        margin-right: 30px
        color: #439beb
        line-height: 66px
        border-right: 1px solid #b5b5b5
        font-size: 22px
</style>